// The offer a guest picked (from a popup, deal card, banner or /offers page)
// follows them through the property page to checkout, where it's applied for them.
// Session-scoped on purpose: a new visit starts clean.

const KEY = 'jc_active_offer';

export function rememberOffer(code) {
  const clean = String(code || '').trim().toUpperCase();
  if (!clean) return;
  try {
    sessionStorage.setItem(KEY, clean);
  } catch {
    // storage blocked — the ?coupon= link still works
  }
}

export function activeOfferCode() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function forgetOffer() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

/** ?coupon=CODE from a query string (also remembers it). */
export function offerFromSearch(search) {
  const code = new URLSearchParams(search || '').get('coupon');
  if (code) rememberOffer(code);
  return code ? code.trim().toUpperCase() : '';
}
